export default function appendTypeToSources(sources) {
  const filteredSources = sources.filter(({ src, type }) => {
    const sourcePathname = new URL(src).pathname;
    return sourcePathname.match(/\.mp4$/) || type === 'mp4' || sourcePathname.match(/\.m3u8$/);
  });

  return filteredSources.map(({ src, type, label, selected = false }) => {
    let actualType;
    const sourcePathname = new URL(src).pathname;
    if (sourcePathname.match(/\.mp4$/) || type === 'mp4') {
      actualType = 'video/mp4';
    } else if (sourcePathname.match(/\.m3u8$/)) {
      actualType = 'application/x-mpegURL';
    }

    return {
      src,
      label,
      type : actualType,
      selected
    };
  });
}
